
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation, Link } from "react-router-dom";
import backend from "../../../../api";
import {
  auth_actions,
  global_actions,
  adcard_actions,
} from "../../../../redux-store";
import ClipLoader from "react-spinners/ClipLoader";
import { Notification } from "../../../../utils";
import Modal from "react-responsive-modal";
import { useDispatch, useSelector } from "react-redux";
import useFormState from "../../../../utils/useFormState";
import ReactPaginate from "react-paginate";
import { Helmet } from "react-helmet";
import useDebounce from "./AdWorkShop/hooks/useDebounce";
import { toast } from "react-toastify";
import CommonAutocomplete from "../../../../utils/CommonAutocomplete";

const MyContacts = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth);
  const adcards = useSelector((state) => state.adcard);
  const dispatch = useDispatch();
  const [state, setState] = useState([]);
  const [myCards, setMyCards] = useState([]);
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [email, setEmail] = useState("");
  const [emails, setEmails] = useState([]);
  const [cardId, setCardId] = useState(null);
  const [phone, setPhone] = useState("");
  const [disableBoxes, setDisableBoxes] = useState(false);
  const [card, setCard] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState();
  const [messageModal, setMessageModal] = useState(false);
  const [checkedState, setCheckedState] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [allContacts, setAllContacts] = useState(false);
  const [pageContacts, setPageContacts] = useState("");
  const [uploadModal, setUploadModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPageContacts, setSelectedPageContacts] = useState(false);

  const { handleSubmit, register, errors } = useForm();
  const {
    formValues,
    handleChange,
    isButtonDisabled,
    setFormValues,
  } = useFormState({
    name: "",
    email: "",
    phone: "",
  });
  const debouncedSearch = useDebounce(search, 500);
  useEffect(() => {
    setFormValues({
      name: "",
      email: "",
      phone: "",
    });
  }, [addModal, setFormValues]);
  useEffect(() => {
    if (cardId) {
      const selectedCard = myCards.find((card) => card._id === cardId);
      setCard(selectedCard);
    }
  }, [cardId, myCards]);

  const fetchProductsOnOpen = () => {
    if (!myCards.length) {
      setLoadingProducts(true); // Start loading when dropdown opens
      dispatch(
        adcard_actions.fetch_adcard({
          member_user: user.user._id,
          isActive: true,
          limit: 9999,
        })
      )
        .then((response) => {
          if (response?.data) {
            setMyCards(response.data); // Set ad cards data
          }
        })
        .catch((error) => {
          console.error("Error fetching ad cards:", error);
        })
        .finally(() => setLoadingProducts(false)); // Stop loading after data is fetched
    }
  };

  const getContactList = (search = "", page = 1, limit = 5) => {
    setLoading(true);
    setState([]);
    if (user) {
      backend
        .get("/membercontacts", {
          params: {
            member: user.user._id,
            page: page,
            limit: limit,
            search: search,
          },
        })
        .then(({ data: { data, totalPages, currentPage } }) => {
          setState(data);
          setTotalPages(totalPages);
          setCurrentPage(currentPage);
          setLoading(false);
          // setCheckedState(new Array(data.length).fill(false));
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getContactList(debouncedSearch, currentPage); // Fetch contacts when currentPage changes
  }, [currentPage, user, debouncedSearch]);

  useEffect(() => {
    if (state?.length > 0) {
      const pageEmails = state.map((contact) => contact.email);
      const emailExist = pageEmails.every((email) => emails.includes(email));
      setSelectedPageContacts(emailExist);
    }
  }, [emails?.length, state?.length]);

  const openModal = () => {
    setAddModal(true);
  };
  const edit = () => {
    submitEditModal();
    setEditModal(false);
  };

  const handleFilterChange = (val) => {
    setCardId(val);
  };
  useEffect(() => {
    if (cardId) {
      const find = myCards.filter((i) => {
        return i._id === cardId;
      });
      setCard(find[0]);
    }
  }, [cardId, myCards]);

  const validateFields = (data) => {
    if (!data.email && !data.phone) {
      return "Either email or phone must be provided.";
    }
    return true;
  };

  const submitModal = () => {
    const status = new Notification();
    const validationError = validateFields({
      email: formValues.email,
      phone: formValues.phone,
    });

    if (validationError !== true) {
      return status.set_toast("error", validationError);
    }

    if (user) {
      setIsSubmitting(true);
      dispatch(global_actions.loading(true));
      backend
        .post("/membercontacts", {
          member: user.user._id,
          name: formValues.name,
          email: formValues.email,
          phone: formValues.phone,
        })
        .then(({ data: { data, message } }) => {
          setState((state) => [...state, data]);
          status.set_toast("success", message);
        })
        .catch((err) =>
          status.set_toast(
            "error",
            err.response ? err.response.data.message : err.message
          )
        )
        .finally(() => {
          status.show_toast();
          dispatch(global_actions.loading(false));
          setEmail("");
          setName("");
          setPhone("");
          setAddModal(false);
          setIsSubmitting(false);
        });
    }
  };

  const deleteHandler = (val) => {
    const status = new Notification();
    if (user) {
      setIsDeleting(true);
      dispatch(global_actions.loading(true));
      backend
        .delete(`/membercontacts/?membercontacts_id=${val}`)
        .then(({ data: { data, message } }) => {
          status.set_toast("success", message);
          // setState(data);
          if (state.length === 1 && currentPage > 1) {
            setCurrentPage(currentPage - 1);
            // getContactList(debouncedSearch, currentPage - 1);
          } else {
            getContactList(debouncedSearch, currentPage);
          }
        })
        .catch((err) =>
          status.set_toast(
            "error",
            err.response ? err.response.data.message : err.message
          )
        )
        .finally(() => {
          status.show_toast();
          setDeleteModal(false);
          dispatch(global_actions.loading(false));
          setIsDeleting(false);
        });
    }
  };

  const submitEditModal = () => {
    const status = new Notification();
    const validationError = validateFields({ email, phone });

    if (validationError !== true) {
      return status.set_toast("error", validationError);
    }

    if (user) {
      setIsSubmitting(true);
      dispatch(global_actions.loading(true));
      backend
        .put(`/membercontacts/${id}`, {
          member: user.user._id,
          name: name,
          email: email,
          phone: phone,
        })
        .then(({ data: { data, message } }) => {
          const updatedState = state.map((contact) =>
            contact._id === data._id ? data : contact
          );
          setState(updatedState);
          status.set_toast("success", message);
        })
        .catch((err) =>
          status.set_toast(
            "error",
            err.response ? err.response.data.message : err.message
          )
        )
        .finally(() => {
          status.show_toast();
          dispatch(global_actions.loading(false));
          setEditModal(false); // Close the edit modal
          setIsSubmitting(false);
        });
    }
  };

  const handleAllContacts = (e) => {
    setAllContacts(e.target.checked);
    setCheckedState([]);
    setEmails([]);
    setPageContacts("");
  };

  const handleFromCurrentPage = (e) => {
    const currentPageEmails = state?.map((contact) => contact?.email);
    if (e.target.checked) {
      setEmails((prev) => Array.from(new Set([...prev, ...currentPageEmails])));
    } else {
      setEmails((prev) =>
        prev.filter((item) => !currentPageEmails.includes(item))
      );
    }
    setSelectedPageContacts(e.target.checked);
  };

  const checkBoxHandler = (e) => {
    const selectedContact = e.target.value;
    if (e.target.checked) {
      setEmails((prev) => [...prev, selectedContact]);
    } else {
      setEmails((prev) => prev.filter((item) => item !== selectedContact));
    }
  };

  // const selectAll = (val) => {
  //   setPageContacts(val);
  //   let arr = [];
  //   if (val === "Select All") {
  //     const allEmails = state.map((contact) => arr.push(contact.email));
  //     setCheckedState(new Array(state.length).fill(true));
  //     setEmails(arr);
  //     setDisableBoxes(!disableBoxes);
  //   } else {
  //     setEmails(arr);
  //     setCheckedState(new Array(state.length).fill(false));
  //     setDisableBoxes(!disableBoxes);
  //   }
  // };

  // const checkBoxHandler = (position, val) => {
  //   const updatedCheckedState = checkedState.map((item, index) => {
  //     if (index === position) {
  //       if (checkedState[index] === false) {
  //         setEmails((i) => [...i, val]);
  //       } else {
  //         const newList = emails.filter((i, index) => i !== val);
  //         setEmails(newList);
  //       }
  //       return !item;
  //     } else {
  //       return item;
  //     }
  //   });
  //   setCheckedState(updatedCheckedState);
  // };

  const sendEmails = () => {
    const status = new Notification();
    setMessageModal(false);

    if (user) {
      dispatch(global_actions.loading(true));
      const test = {
        sender_email: user.user.email,
        send_emails: emails,
        shared_link: card.shareable_link,
        product_details: card.product.product_discription,
        message: message,
        member_user: user.user._id,
        selectAll: allContacts,
      };

      backend
        .post("/sharedlink/sendemails", test)
        .then(({ data: { data, message } }) => {
          status.set_toast("success", "Emailed successfully!");
        })
        .catch((error) => {
          status.set_toast(
            "error",
            error.response ? error.response.data.message : error.message
          );
        })
        .finally(() => {
          setMessage("");
          status.show_toast();
          dispatch(global_actions.loading(false));
        });
    }
  };
  const handleCsvUpload = (event) => {
    setIsLoading(true);
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("member", user.user._id);
      backend
        .post("/membercontacts/csv-upload", formData)
        .then((res) => {
          getContactList();
          toast.success("CSV Uploaded Successfully");
          setUploadModal(false);
        })
        .catch((err) => {
          toast.error(err.response ? err.response.data.message : err.message);
        })
        .finally(() => {
          setIsLoading(false);
          setUploadModal(false);
        });
    }
  };
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // ReactPaginate uses zero-based indexing
    setLoading(true);
  };

  return (
    <>
      <Helmet>
        <title>eksplode! | My Contacts</title>
      </Helmet>
      <div className="dashboard">
        <div className="box-account box-info">
          <div className="box-head">
            <h2>My Contacts</h2>
          </div>
          <div className="row mt-3 justify-content-end">
            <button
              className="btn btn-solid mr-2"
              onClick={() => setUploadModal(true)}
            >
              Upload Contacts
            </button>
            <button
              className="btn btn-solid mr-2"
              onClick={
                cardId && (emails.length > 0 || allContacts)
                  ? () => setMessageModal(true)
                  : null
              }
              disabled={
                allContacts
                  ? !cardId || !allContacts
                  : !cardId || emails?.length === 0
              }
            >
              Send Email
            </button>
            <button className="btn btn-solid" onClick={() => openModal()}>
              Add Contacts
            </button>
          </div>
          <div className="row mt-3">
            <div className="col-lg-12  mx-auto register-page section-b-space">
              <div className="theme-card">
                <div className="form-row">
                  <div className="col-md-6 mb-2">
                    <CommonAutocomplete
                      label="Select Product"
                      options={myCards}
                      value={
                        myCards.find((card) => card._id === cardId) || null
                      }
                      onChange={(newValue) => setCardId(newValue?._id)}
                      getOptionLabel={(option) =>
                        option?.product?.product_name || ""
                      }
                      isDisabled={false}
                      loading={loadingProducts}
                      onOpen={fetchProductsOnOpen}
                      height={37}
                    />
                  </div>

                  {/* <div className="col-md-6 mb-2">
                    <select
                      value={pageContacts}
                      className="form-control mb-0"
                      onChange={(e) => selectAll(e.target.value)}
                    >
                      <option selected value="">
                        Select All Contacts From Current Page.
                      </option>
                      {["Select All", "Unselect All"].map((option, i) => {
                        return (
                          <option value={option} key={i}>
                            {option}{" "}
                          </option>
                        );
                      })}
                    </select>
                  </div> */}
                  <div className="col-md-6 ">
                    <input
                      type="text"
                      className="form-control mb-0"
                      placeholder="Search contacts"
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <div className="d-flex align-items-center justify-content-end h-100">
                      <input
                        type="checkbox"
                        id="select-all"
                        className="mr-2"
                        onChange={(e) => handleAllContacts(e)}
                      />
                      <label htmlFor="select-all" className="mb-0">
                        Select All
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="d-flex align-items-center justify-content-end h-100">
                      <input
                        type="checkbox"
                        id="select-all-current-page"
                        className="mr-2"
                        onChange={handleFromCurrentPage}
                        checked={selectedPageContacts}
                      />
                      <label htmlFor="select-all-current-page" className="mb-0">
                        Select All From Current Page
                      </label>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="py-5 d-flex justify-content-center w-100">
                    <ClipLoader color={"#000000"} loading={loading} size={60} />
                  </div>
                ) : state?.length > 0 ? (
                  <div>
                    {state.map((contact, index) => {
                      return (
                        <div>
                          <form className="theme-form">
                            <div
                              className="box-account box-info mt-3"
                              key={contact._id}
                            >
                              <div className="row">
                                <div className="col-lg-12 px-5">
                                  <div className="box">
                                    <div className="box-title">
                                      <h3>
                                        <input
                                          type="checkbox"
                                          id="contact"
                                          className="ml-50"
                                          name="send_emails"
                                          value={contact.email}
                                          disabled={allContacts ? true : false}
                                          onChange={checkBoxHandler}
                                          checked={
                                            allContacts
                                              ? allContacts
                                              : emails.some(
                                                  (email) =>
                                                    email === contact.email
                                                )
                                          }
                                          // disabled={disableBoxes}
                                          // onChange={(e) => {
                                          //   checkBoxHandler(
                                          //     index,
                                          //     e.target.value
                                          //   );
                                          //   // checkboxHandler(e.target.value)
                                          // }}
                                        />
                                      </h3>
                                      <h3>
                                        <span>
                                          Contact Name &mdash;{" "}
                                          <b>{contact.name}</b>
                                        </span>

                                        <br />
                                        <small className="text-muted">
                                          Contact Email &mdash; {contact.email}
                                        </small>
                                        <br />
                                        <small className="text-muted">
                                          Phone &mdash; {contact.phone}
                                        </small>
                                        <br />
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                          <div className="box-content">
                            <div className="d-flex flex-wrap justify-content-end ">
                              <button
                                className="btn btn-solid mr-3 "
                                onClick={() => {
                                  setDeleteModal(true);
                                  setDeleteId(contact._id);
                                }}
                              >
                                Delete Contact
                              </button>
                              <button
                                className="btn btn-solid "
                                onClick={() => {
                                  setEditModal(true);
                                  setName(contact.name);
                                  setEmail(contact.email);
                                  setPhone(contact.phone);
                                  setId(contact._id);
                                }}
                              >
                                Edit Contact
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="d-flex justify-content-center mt-5">
                      <ReactPaginate
                        previousLabel={"<<"}
                        nextLabel={">>"}
                        breakLabel={"..."}
                        pageCount={totalPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                      />
                    </div>
                  </div>
                ) : (
                  <form className="theme-form">
                    <div className="box-account box-info mt-3">
                      <div className="my-5 row justify-content-center">
                        <h3>No Contacts Available</h3>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal open={addModal} onClose={() => setAddModal(false)} center>
          <div className="container px-5 pt-5 ">
            <div className="form-row ">
              <div className="col-lg-12">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control mb-0"
                  id="name"
                  name="name"
                  value={formValues.name}
                  onChange={handleChange}
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                  })}
                />
                <label htmlFor="name" className="error">
                  {errors.name && errors.name.message}
                </label>
              </div>
            </div>
            <div className="form-row ">
              <div className="col-lg-12">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  className="form-control mb-0 "
                  id="email"
                  name="email"
                  value={formValues.email}
                  onChange={handleChange}
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                    pattern: {
                      value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                      message: "This must be a valid Email ",
                    },
                  })}
                />
                <label htmlFor="email" className="error">
                  {errors.email && errors.email.message}
                </label>
              </div>
            </div>
            <div className="form-row ">
              <div className="col-lg-12">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                  className="form-control mb-0 "
                  id="phone"
                  name="phone"
                  value={formValues.phone}
                  onChange={handleChange}
                  ref={register({
                    required: {
                      value: false,
                    },
                  })}
                />
                <label htmlFor="phone" className="error">
                  {errors.phone && errors.phone.message}
                </label>
              </div>
            </div>

            <button
              className="btn btn-solid row mt-3 justify-content-center"
              onClick={handleSubmit(submitModal)}
              disabled={isButtonDisabled}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </Modal>
        <Modal open={editModal} onClose={() => setEditModal(false)} center>
          <div className="container px-5 pt-5 ">
            <div className="form-row mr-3">
              <div className="col-md-12">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control mb-0"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                  })}
                />

                <label htmlFor="name" className="error">
                  {errors.name && errors.name.message}
                </label>
              </div>
            </div>

            <div className="form-row mr-3">
              <div className="col-md-12">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  className="form-control mb-0 "
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                    pattern: {
                      value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                      message: "This must be a valid Email",
                    },
                  })}
                />
                <label htmlFor="email" className="error">
                  {errors.email && errors.email.message}
                </label>
              </div>
            </div>
            <div className="form-row mr-3">
              <div className="col-md-12">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                  className="form-control mb-0 "
                  id="phone"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  ref={register({
                    required: {
                      value: false,
                    },
                  })}
                />
                <label htmlFor="phone" className="error">
                  {errors.phone && errors.phone.message}
                </label>
              </div>
            </div>

            <button
              className="btn btn-solid row mt-3 justify-content-center"
              onClick={handleSubmit(submitEditModal)}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </Modal>
        <Modal open={deleteModal} onClose={() => setDeleteModal(false)} center>
          <div className="container px-5 pt-5 ">
            <div className="form-row mr-3">
              <div className="col-md-12 justify-content-center mb-3">
                <h3>Are you sure?</h3>
              </div>
              <br />
              <button
                className="btn btn-solid mt-3"
                onClick={() => {
                  setDeleteModal(false);
                }}
              >
                Back
              </button>
              <button
                className="btn btn-solid ml-3 mt-3"
                onClick={() => {
                  deleteHandler(deleteId);
                }}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          open={messageModal}
          onClose={() => setMessageModal(false)}
          center
        >
          <form className="container px-5 pt-5">
            <div className="form-row mr-3">
              <div className="col-md-12 justify-content-center mb-3">
                <h3>
                  Please type a message you want to add in your mail for your
                  contacts.
                </h3>
              </div>
              <div className="col-md-12">
                <label htmlFor="message">Message</label>
                <textarea
                  type="text"
                  className="form-control mb-0"
                  id="message"
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                  })}
                  rows="6"
                />

                <label htmlFor="message" className="error">
                  {errors.message && errors.message.message}
                </label>
              </div>
            </div>
            <button
              className="btn btn-solid row mt-3 justify-content-center"
              onClick={handleSubmit(sendEmails)}
            >
              Send Email
            </button>
          </form>
        </Modal>
        <Modal open={uploadModal} onClose={() => setUploadModal(false)} center>
          <div className="d-flex flex-column py-5" style={{ width: "300px" }}>
            <span>
              <i className="fa fa-info-circle" aria-hidden="true"></i>{" "}
              <a
                href="https://c5m-assets.s3.amazonaws.com/1721813296241.csv"
                download="contact-sample.csv"
              >
                Download Sample
              </a>{" "}
              before uploading csv and make sure to follow the same rows and
              columns
            </span>
            <label htmlFor="csvUpload" className="btn btn-solid mb-0 mt-2">
              <input
                type="file"
                accept=".csv"
                onChange={handleCsvUpload}
                style={{ display: "none" }}
                id="csvUpload"
              />
              <span>Upload CSV</span>
            </label>
            {isLoading && (
              <div className=" d-flex justify-content-center w-100 mt-2">
                <ClipLoader color={"#000000"} loading={isLoading} size={30} />
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default MyContacts;
